{
  "selectAsField": "\"{value}\"을(를) {fieldName}(으)로 선택",
  "typeToSearchField": "{fieldName}을(를) 검색하려면 입력하세요",
  "licenseFieldLabel": "번호판 선택(예: 215BG2)",
  "licenseFieldName": "번호판",
  "licensePlaceholder": "번호판으로 검색",
  "dotFieldLabel": "DOT 번호 선택",
  "dotFieldName": "DOT 번호",
  "dotPlaceholder": "DOT 번호로 검색"
}
